import React from 'react';
import { Trophy } from 'lucide-react';

export function ServiceRanking({ services }) {
  if (!services || services.length === 0) {
    return (
      <div className="card-surface p-6" data-testid="service-ranking">
        <h3 className="font-heading text-base font-medium text-[#1A1A1A] mb-4 flex items-center gap-2">
          <Trophy className="h-4 w-4 text-[#D4AF37]" />
          Service Popularity
        </h3>
        <p className="text-sm text-stone-400 text-center py-6">No service data for this period.</p>
      </div>
    );
  }

  const maxBookings = Math.max(...services.map(s => s.bookings), 1);

  return (
    <div className="card-surface p-6" data-testid="service-ranking">
      <h3 className="font-heading text-base font-medium text-[#1A1A1A] mb-4 flex items-center gap-2">
        <Trophy className="h-4 w-4 text-[#D4AF37]" />
        Service Popularity
      </h3>

      <div className="space-y-3">
        {services.map((svc, i) => {
          const pct = (svc.bookings / maxBookings) * 100;
          const medals = ['bg-[#D4AF37] text-white', 'bg-stone-300 text-white', 'bg-amber-700 text-white'];
          const medalClass = i < 3 ? medals[i] : 'bg-stone-100 text-stone-500';

          return (
            <div key={svc.service_id} className="group" data-testid={`service-rank-${i}`}>
              <div className="flex items-center gap-3 mb-1">
                <span className={`w-6 h-6 rounded-full text-xs font-bold flex items-center justify-center flex-shrink-0 ${medalClass}`}>
                  {i + 1}
                </span>
                <span className="flex-1 text-sm font-medium text-[#1A1A1A] truncate">{svc.name}</span>
                <span className="text-xs text-stone-500">{svc.bookings} booking{svc.bookings !== 1 ? 's' : ''}</span>
                <span className="text-xs font-semibold text-emerald-600 w-16 text-right">£{svc.revenue.toFixed(0)}</span>
              </div>
              <div className="ml-9 h-1.5 bg-[#F9F6F0] rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-700"
                  style={{
                    width: `${pct}%`,
                    background: i === 0 ? '#D4AF37' : i === 1 ? '#a1a1aa' : i === 2 ? '#92400e' : '#d6d3d1'
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
